import { useState } from 'react';
import type { VinDecodeResult } from '../api/vinScanner';
import { useVinDecoder } from './useVinDecoder';
import { useVinScanner } from './useVinScanner';
import { toDataUrl } from '../lib/dataUrl';

export interface ScannedVin {
  vin: string;
  vehicle: VinDecodeResult | null;
}

/**
 * Read a VIN off a picture with the backend's reader, then decode it, as
 * the old scanner screen did. Null when no VIN could be read; the screen
 * then offers to type it.
 */
export function useScanVin() {
  const { scanImage } = useVinScanner();
  const { decodeVin } = useVinDecoder();
  const [reading, setReading] = useState(false);

  const scan = async (file: File): Promise<ScannedVin | null> => {
    setReading(true);
    try {
      const result = await scanImage(await toDataUrl(file));
      if (!result?.vinFound || !result.vin) return null;
      return { vin: result.vin, vehicle: await decodeVin(result.vin) };
    } finally {
      setReading(false);
    }
  };

  return { scan, reading };
}
